import '.a{display:flex;}.ssr-plugin'
import '.en{flex-grow:1;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.am{overflow:hidden;}.ssr-plugin'
import '.iw{margin:16px 0px 16px 16px;}.ssr-plugin'
import '.eb{flex-shrink:0;}.ssr-plugin'
import { ReactElement, ReactNode } from 'react'
import { Sidebar } from '../Sidebar/index.js'
import { Group } from './Group.js'
import { IconProps } from '../Icon/index.js'
import { capitalize, normalize } from '../../utils/text.js'
import { styled } from 'inlines'
import { useLocation } from '../../hooks/useCmsParams.js'

export const Tab = ({
  children = [],
}: {
  children: ReactNode
  name: string
  icon?: IconProps['variant']
  hidden?: boolean
}) => {
  children = Array.isArray(children) ? children : [children]

  const menuGroups: ReactElement[] = []
  const menuItems: ReactElement[] = []
  let [location, navigate] = useLocation()
  let activeChild: ReactElement
  let firstChild: ReactElement
  let matchLen = 0
  let itemsCnt = 0
  let match

  const childToMenuItem = (child: any) => {
    const { section, name = section, page, id, icon, counter } = child.props
    let path = `/${normalize(section)}`
    if (page) {
      path += id ? `/${page}/${id}` : `/${page}`
    } else if (id) {
      path += `/edit/${id}`
    }

    location ||= path
    firstChild ??= child

    if (location.startsWith(path) && path.length > matchLen) {
      activeChild = child
      matchLen = path.length
      match = path
    } else {
      activeChild ??= child
      match ??= path
    }

    if (!section) {
      return null
    }

    itemsCnt++

    return (
      <Sidebar.Item key={section} icon={icon} value={path} counter={counter}>
        {capitalize(name)}
      </Sidebar.Item>
    )
  }

  const parseChildren = (children: Iterable<ReactNode>) => {
    for (const child of children) {
      // @ts-ignore
      if (typeof child === 'object') {
        if ('type' in child) {
          if (child.type === Group) {
            const { name, children } = child.props
            menuGroups.push(
              <Sidebar.Group key={name} title={capitalize(name)}>
                {children.map?.(childToMenuItem) ?? childToMenuItem(children)}
              </Sidebar.Group>,
            )
          } else {
            menuItems.push(childToMenuItem(child))
          }
        } else if (Array.isArray(child)) {
          parseChildren(child)
        }
      }
    }
  }

  parseChildren(children)

  if (menuItems.length) {
    menuGroups.unshift(
      <Sidebar.Group key={'_' + menuGroups.length} title="">
        {menuItems}
      </Sidebar.Group>,
    )
  }

  return (
    <div className="a en f am"
      key={menuGroups.length}
    >
      {itemsCnt < 2 ? null : (
        <div className="am iw eb"
        >
          <Sidebar value={match} onChange={navigate} side={false}>
            <Sidebar.Items>{menuGroups}</Sidebar.Items>
          </Sidebar>
        </div>
      )}
      {activeChild || firstChild || children}
    </div>
  )
}
